import { FormError as AriaKitFormError, useFormContext, useStoreState } from '@ariakit/react'
import { ComponentProps } from 'react'
import styled from 'styled-components'

import { ErrorMessage } from '@syconium/little-miss-figgy'

export const FormError = (props: ComponentProps<typeof AriaKitFormError>) => {
  const formStore = useFormContext()
  const error = useStoreState(formStore, () => formStore?.getError(props.name))

  return (
    <CollapsingErrorMessageWrapper inError={!!error}>
      <AriaKitFormError {...props} />
    </CollapsingErrorMessageWrapper>
  )
}

const CollapsingErrorMessageWrapper = styled(
  ({
    inError: _inError,
    ...props
  }: {
    inError: boolean
    children?: React.ReactNode
    className?: string
  }) => {
    return <ErrorMessage {...props} />
  }
)`
  ${o => (o.inError ? null : 'display: contents;')}
`
